import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../data/content';
export function Guarantee() {
  return <section aria-labelledby="garantia-title" className="w-full bg-cream-50 px-5 py-20 sm:py-24" data-id="element-83" data-mp="1o33smclbhkfn">
      <div className="mx-auto flex max-w-3xl flex-col items-center gap-6 rounded-2xl border border-rose-200 bg-rose-50 p-7 sm:flex-row sm:items-start sm:p-10" data-id="element-84" data-mp="222wjc7wug0nm">
        <ShieldCheckIcon aria-hidden="true" className="h-10 w-10 shrink-0 text-rose-500" data-id="element-85" data-mp="19e7lqiuzydgm" />
        <div data-id="element-86" data-mp="14g67cb8in2bh">
          <h2 id="garantia-title" className="text-center font-display text-3xl font-semibold text-plum-800 sm:text-left sm:text-4xl" data-id="element-87" data-mp="14gfnz87o7x4i">
            Garantía completa de 7 días
          </h2>
          <div className="mt-5 space-y-4 text-base leading-relaxed text-plum-500" data-id="element-88" data-mp="1ec98bdrmsuwu">
            <p data-id="element-89" data-mp="qn7vzffogzma">Abre el sistema completo. Usa el material esta semana.</p>
            <p data-id="element-90" data-mp="lpohcef2iktt">
              Si sientes que no es claro, práctico o útil para lo que estás viviendo, escríbenos a{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} className="font-medium text-rose-600 underline decoration-rose-300 underline-offset-4 transition-colors duration-150 hover:text-rose-500" data-id="element-91" data-mp="oygncjtz1mcx">
                {SUPPORT_EMAIL}
              </a>{' '}
              dentro de los 7 días.
            </p>
            <p className="font-medium text-plum-800" data-id="element-92" data-mp="12t0t3z91cdcj">
              Te devolvemos el 100% de tu dinero. Sin preguntas. Sin formularios. Sin
              complicaciones.
            </p>
          </div>
        </div>
      </div>
    </section>;
}